import React from 'react';
import {formatCurrency, trackClick} from '../util/util.js';
import adiTrack from '../util/adi_track.js'
import { ReCaptcha } from 'react-recaptcha-google'
import { v4 as uuidv4 } from 'uuid';
import { sha256 } from 'js-sha256';
import publicIp from 'public-ip';
import {leadFormCredentials, leadFormPhoneNumbers, listHubSource} from '../util/listhub_source'

const initialState = {
    'classifieds.attachment.text_attachment:21': "", // name
    'classifieds.attachment.text_attachment:22': "", // email
    'classifieds.attachment.text_attachment:23': "", // phone
    'classifieds.attachment.text_attachment:24': "", // comments
    'classifieds.attachment.text_attachment:25': "", // privacy policy checked
    'classifieds.attachment.text_attachment:26': "", // lead recipient
    'classifieds.attachment.text_attachment:1': "",  // community name
    'classifieds.attachment.text_attachment:7': "",  // community phone
    'classifieds.attachment.text_attachment:8': "",  // community email
    'classifieds.attachment.text_attachment:11': "", // community comments
    'classifieds.attachment.text_attachment:12': "", // community privacy policy checked
    'classifieds.attachment.text_attachment:13': "", // community lead recipient
    nameError: "",
    emailError: "",
    thanksDisplay: "none",
    formDisplay: "block",
    emailSent: false,
    contact_method: "text",
}

const errorStyles = {
    color : 'red',
    fontSize: '11'
};

const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

class HiddenFormInputs extends React.PureComponent {
    render() {
        const {item, isCommunity, affiliate, fullName} = this.props
        const lead_customer_id = (!!item.agent_marketing_level &&
                                    item.agent_marketing_level.toUpperCase() === 'ENHANCED' &&
                                    item.agent_email)
                ? item.agent_id : item.broker_id;
        const pmc_customer_id = item.property_management_id;
        const privatePartyEmail = (item.listing_email) ? 'true' : 'false';

        if (isCommunity) {
            return (
                <>
                <input type="hidden" name="tp" value={affiliate} />
                <input type="hidden" name="category" value="community" />
                <input type="hidden" name="detail_2014" value="true" />
                <input type="hidden" name="temp_type" value="detail" />
                <input type="hidden" name="finder" value="rent" />
                <input type="hidden" name="ad_id" value={item.ad_id} />

                <input type="hidden" name="classification" value="real estate" />
                <input type="hidden" name="custid" value="" />
                <input type="hidden" name="property" value={fullName + '.com'} />

                <input type="hidden" name="classifieds.ad_response.user_id" value="-1" />
                <input type="hidden" name="classifieds.ad_response.customer_id" value={pmc_customer_id} />
                <input type="hidden" name="classifieds.ad_response.status" value="New" />
                <input type="hidden" name="classifieds.ad_response.ad_id" value={item.ad_id} />
                <input type="hidden" name="classifieds.ad_response.created_by" value="mdApartments Lead" />

                <input type="hidden" name="classifieds.attachment.object_id:1" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:1" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:1" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:1" value="name" />
                <input type="hidden" name="classifieds.attachment.object_id:2" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:2" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:2" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:2" value="address" />
                <input type="hidden" name="classifieds.attachment.object_id:3" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:3" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:3" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:3" value="city" />
                <input type="hidden" name="classifieds.attachment.object_id:4" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:4" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:4" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:4" value="state" />
                <input type="hidden" name="classifieds.attachment.object_id:5" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:5" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:5" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:5" value="postal_code" />
                <input type="hidden" name="classifieds.attachment.object_id:6" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:6" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:6" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:6" value="country" />
                <input type="hidden" name="classifieds.attachment.object_id:7" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:7" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:7" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:7" value="phone" />
                <input type="hidden" name="classifieds.attachment.object_id:8" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:8" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:8" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:8" value="email" />
                <input type="hidden" name="classifieds.attachment.object_id:9" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:9" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:9" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:9" value="movein" />
                <input type="hidden" name="classifieds.attachment.object_id:10" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:10" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:10" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:10" value="lease_term" />
                <input type="hidden" name="classifieds.attachment.object_id:11" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:11" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:11" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:11" value="comments" />

                <input type="hidden" name="classifieds.attachment.object_id:12" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:12" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:12" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:12" value="privacy_policy_checked" />
                <input type="hidden" name="classifieds.attachment.text_attachment:12" value="off" />

                <input type="hidden" name="classifieds.attachment.object_id:13" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:13" value="LEAD" />
                <input type="hidden" name="classifieds.attachment.type:13" value="Community" />
                <input type="hidden" name="classifieds.attachment.name:13" value="LeadRecipient" />
                <input type="hidden" name="classifieds.attachment.text_attachment:13" value="move.com" />
                </>
            )
        } else {
            return (
                <>
                <input type="hidden" name="tp" value={affiliate} />
                <input type="hidden" name="actn" value="SEND" />
                <input type="hidden" name="category" value="AJAX broker agent mail" />
                <input type="hidden" name="privatePartyEmail" value={privatePartyEmail} />
                <input type="hidden" name="detail_2014" value="true" />
                <input type="hidden" name="temp_type" value="detail" />
                <input type="hidden" name="finder" value="buy" />
                <input type="hidden" name="ad_id" value={item.ad_id} />

                <input type="hidden" name="classification" value="real estate" />
                <input type="hidden" name="custid" value={lead_customer_id} />
                <input type="hidden" name="property" value={fullName + '.com'} />
                <input type="hidden" name="lead_recipient" value="move.com" />

                <input type="hidden" name="classifieds.attachment.object_id:21" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:21" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:21" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:21" value="Name" />

                <input type="hidden" name="classifieds.attachment.object_id:22" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:22" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:22" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:22" value="Email" />

                <input type="hidden" name="classifieds.attachment.object_id:23" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:23" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:23" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:23" value="Phone" />

                <input type="hidden" name="classifieds.attachment.object_id:24" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:24" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:24" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:24" value="Comments" />

                <input type="hidden" name="classifieds.attachment.object_id:25" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:25" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:25" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:25" value="PrivacyPolicyChecked" />
                <input type="hidden" name="classifieds.attachment.text_attachment:25" value="off" />

                <input type="hidden" name="classifieds.attachment.object_id:26" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:26" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:26" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:26" value="LeadRecipient" />
                <input type="hidden" name="classifieds.attachment.text_attachment:26" value="move.com" />

                <input type="hidden" name="resp_id" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.ad_response.ad_id" value={item.ad_id} />
                <input type="hidden" name="classifieds.ad_response.customer_id" value={lead_customer_id} />
                <input type="hidden" name="classifieds.ad_response.user_id" value="-5" />
                <input type="hidden" name="classifieds.ad_response.status" value="New" />
                <input type="hidden" name="classifieds.ad_response.created_by" value="mdRealestate Leads" />

                <input type="hidden" name="classifieds.attachment.object_id:1" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:1" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:1" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:1" value="Number" />
                <input type="hidden" name="classifieds.attachment.text_attachment:1" value={item.ad_number} />

                <input type="hidden" name="classifieds.attachment.object_id:2" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:2" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:2" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:2" value="House_Status" />
                <input type="hidden" name="classifieds.attachment.text_attachment:2" value={item.house_status} />

                <input type="hidden" name="classifieds.attachment.object_id:3" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:3" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:3" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:3" value="Beds" />
                <input type="hidden" name="classifieds.attachment.text_attachment:3" value={item.beds} />

                <input type="hidden" name="classifieds.attachment.object_id:4" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:4" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:4" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:4" value="Baths" />
                <input type="hidden" name="classifieds.attachment.text_attachment:4" value={item.baths} />

                <input type="hidden" name="classifieds.attachment.object_id:5" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:5" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:5" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:5" value="Price" />
                <input type="hidden" name="classifieds.attachment.text_attachment:5" value={formatCurrency(item.price) || ''} />

                <input type="hidden" name="classifieds.attachment.object_id:6" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:6" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:6" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:6" value="Zipcode" />
                <input type="hidden" name="classifieds.attachment.text_attachment:6" value={item.zipcode} />

                <input type="hidden" name="classifieds.attachment.object_id:7" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:7" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:7" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:7" value="Neighborhood" />
                <input type="hidden" name="classifieds.attachment.text_attachment:7" value={item.neighborhood} />

                <input type="hidden" name="classifieds.attachment.object_id:8" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:8" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:8" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:8" value="County" />
                <input type="hidden" name="classifieds.attachment.text_attachment:8" value={item.county} />

                <input type="hidden" name="classifieds.attachment.object_id:10" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:10" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:10" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:10" value="Internet_Address" />
                <input type="hidden" name="classifieds.attachment.text_attachment:10" value={item.internet_address} />

                <input type="hidden" name="classifieds.attachment.object_id:11" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:11" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:11" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:11" value="City" />
                <input type="hidden" name="classifieds.attachment.text_attachment:11" value={item.city} />

                <input type="hidden" name="classifieds.attachment.object_id:12" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:12" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:12" value="ad" />
                <input type="hidden" name="classifieds.attachment.name:12" value="State" />
                <input type="hidden" name="classifieds.attachment.text_attachment:12" value={item.state} />

                <input type="hidden" name="classifieds.attachment.object_id:13" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:13" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:13" value="ad_site" />
                <input type="hidden" name="classifieds.attachment.name:13" value={fullName + '.com'} />
                <input type="hidden" name="classifieds.attachment.text_attachment:13" value={fullName + '.com'} />

                <input type="hidden" name="classifieds.attachment.object_id:14" value="{classifieds.ad_response.id}" />
                <input type="hidden" name="classifieds.attachment.object_type:14" value="AD_RESPONSE" />
                <input type="hidden" name="classifieds.attachment.type:14" value="ad_property" />
                <input type="hidden" name="classifieds.attachment.name:14" value={item.property} />
                <input type="hidden" name="classifieds.attachment.text_attachment:14" value={item.property} />
                </>
            )
        }
    }
}

const dateToLocalISO = (date) => {
    const off    = date.getTimezoneOffset()
    const absoff = Math.abs(off)
    return (new Date(date.getTime() - off*60*1000).toISOString().substr(0,19) +
            (off > 0 ? '-' : '+') +
            (absoff / 60).toFixed(0).padStart(2,'0') + ':' +
            (absoff % 60).toString().padStart(2,'0'))
}

class ListhubContactForm extends React.Component {
    constructor (props) {
        super(props);
        this.state = initialState;
        const {streetAddress, item} = props;
        const {city, state, zipcode, ad_number, web_id} = item;
        const idDisplay = (web_id || ad_number) ? ` (ID #${web_id || ad_number})` : '';
        this.state['message'] = `I am interested in ${streetAddress}, ${city}, ${state} ${zipcode}${idDisplay}.`;
        this.state['initialFocus'] = false;
        this.state['captchaData'] = null;
        this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
    }

    componentDidMount() {
        if (this.captchaDemo) {
            //console.log("started, just a second...")
            this.captchaDemo.reset();
        }
        (async () => {
            this.setState({ customer_ip: await publicIp.v4() })
        })();

    }

    onLoadRecaptcha() {
        if (this.captchaDemo) {
            //console.log("CAPTCHA: onLoad");
            this.captchaDemo.reset();
        }
    }

    verifyCallback(recaptchaToken) {
        // Here you will get the final recaptchaToken!!!
        //console.log(recaptchaToken, "<= your recaptcha token")
        this.setState({captchaData: recaptchaToken});
    }

    handleChange = event => {
        this.setState ({[event.target.name]: event.target.value});
    }

    hash = (s) => {
        /* Simple hash function. */
        let a = 1, c = 0, h, o;
        if (s) {
            a = 0;
            /*jshint plusplus:false bitwise:false*/
            for (h = s.length - 1; h >= 0; h--) {
                o = s.charCodeAt(h);
                a = (a<<6&268435455) + o + (o<<14);
                c = a & 266338304;
                a = c!==0?a^c>>21:a;
            }
        }
        return String(a);
    };

    trackSubmitLead = (item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId) => {
        if (isCommunity) {
            fetch(reportingTrackingPath + ';pc=460', {mode: 'no-cors'});
        } else {
            fetch(reportingTrackingPath + ';pc=206', {mode: 'no-cors'});
            fetch(reportingTrackingPath + ';pc=214', {mode: 'no-cors'});
            if (trackingEnabled) {
                const dataProperty = item.property.toUpperCase();
                try {
                    if (item.listhub_key && listHubProviderId) {
                        const _lh = new window.ListHubTracker({provider: listHubProviderId, test: false});
                        _lh.submit('EMAIL_CLICKED', item.listhub_key);
                    }
                } catch(err) {console.log('listHub error' + err)}
                try {
                    if (typeof(window._LT) !== 'undefined' &&
                        window._LT !== null &&
                        !dataProperty.includes('ADPAY') &&
                        !!item.agent_id_attribute) {
                            window._LT._trackEvent(window._eventType.lead, item.ad_number, item.zipcode, item.agent_id_attribute);
                        }
                } catch(err) {console.log('listtrac error' + err)}
            }
        }
        adiTrack.event('realestate_temp_lead_form_submission');
    }

    validate = (isCommunity) => {
        let nameError = "";
        let emailError = "";
        let phoneError = "";
        let userNameField = 'classifieds.attachment.text_attachment:21';
        let emailNameField = 'classifieds.attachment.text_attachment:22';
        let phoneNameField = 'classifieds.attachment.text_attachment:23';
        if (isCommunity) {
            userNameField = 'classifieds.attachment.text_attachment:1';
            emailNameField = 'classifieds.attachment.text_attachment:8';
            phoneNameField = 'classifieds.attachment.text_attachment:7';
        }

        if (!this.state[userNameField]) {
            nameError = 'Name is required';
        }

        if (this.state[emailNameField].search(/^(\w([-._\w]*\w)*@(\w[-_\w]*\w\.)+\w{2,9})$/)) {
            emailError = 'Invalid Email';
        }

        if (!this.state[emailNameField]) {
            emailError = 'Email is required';
        }

        if (!phoneRegex.test(this.state[phoneNameField])) {
            phoneError = 'Invalid Phone Number';
        }

        if (!this.state[phoneNameField]) {
            phoneError = 'Phone number is required';
        }

        if (nameError || emailError || phoneError) {
            this.setState({nameError, emailError, phoneError});
            return false;
        }

        return true;
    }

    handleSubmit = (event, item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId) => {
        event.preventDefault();
        const isValid = this.validate(isCommunity);
        const trackSubmitLead = this.trackSubmitLead;
        if (isValid && !this.state.emailSent && this.state.captchaData) {
            const morrisUrl = '//realestate.' + this.props.fullName + '.com/forge/data_entry';
            // //test endpoint
            // const url = 'https://api-test.opcity.com/v3/inquiry';
            //prod endpoint
            const url = 'https://api.opcity.com/v3/inquiry';
            const username = btoa(`${leadFormCredentials[this.props.fullName]}:`);
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Basic ${username}`);
            myHeaders.append("Content-Type", "application/json");

            const formData = new FormData(event.target);
            let userNameField = 'classifieds.attachment.text_attachment:21';
            let emailNameField = 'classifieds.attachment.text_attachment:22';
            let phoneNameField = 'classifieds.attachment.text_attachment:23';
            let messageNameField = 'classifieds.attachment.text_attachment:24';
            if (isCommunity) {
                userNameField = 'classifieds.attachment.text_attachment:1';
                emailNameField = 'classifieds.attachment.text_attachment:8';
                phoneNameField = 'classifieds.attachment.text_attachment:7';
                messageNameField = 'classifieds.attachment.text_attachment:11';
            }
            const userNameValue = this.hash(formData.get(userNameField)); //api requires plain text
            const emailNameValue = this.hash(formData.get(emailNameField)); //api requires plain text
            const phoneNameValue = this.hash(formData.get(phoneNameField)); //api requires plain text
            const messageNameValue = formData.get(messageNameField); //api requires plain text
            const tcpaValue = document.querySelector("#tcpa_value").innerHTML;
            const timeStamp = new Date();
            const maxPrice = this.props.priceRange && this.props.priceRange.lte;
            const requestBody = {
                "lead": {
                    "id": sha256(`${item.ad_id}${phoneNameValue}${timeStamp}`), // a SHA hash of the listing ID + user phone # + timestamp
                    "submit_time": dateToLocalISO(timeStamp),
                    "source": listHubSource[this.props.fullName],
                    "lead_origin": "LDP", //always hard code to 'LDP'
                    "form_url": window.location.href,
                    "primary_lead_type": item.list_type === 'resale' ? 'buy' : 'rental', //customer's motivation
                    "api_version": "3", //always hard code to 1
                    "listhub_metrics_provider_id": item.listhub_key && listHubProviderId, // only send lh provider id when it is listhub item
                    "listhub_listing_key": item.listhub_key, //Passed for listhub listing
                    "tcpa": tcpaValue,
                    "jornaya_id": null,
                    "trusted_form_cert_url": null,
                },
                "consumer": {
                    "name": formData.get(userNameField),
                    "email": formData.get(emailNameField),
                    "phone": formData.get(phoneNameField).replace(phoneRegex, "($1) $2-$3"),
                    "message": messageNameValue,
                    "consumer_ip": this.state.customer_ip,
                    "home_use": null,
                    "price_max": formatCurrency(maxPrice || item.price),
                },
                "consumer_preference": {
                    "contact_method": this.state.contact_method,
                },
                "property": {
                    "property_status": item.house_status,
                    "property_price": formatCurrency(item.price), //api requires us to send price as string
                    "property_type": item.property_type,
                    "property_address_line": `${this.props.streetAddress}, ${item.city}, ${item.state} ${item.zipcode}`, //reuse existing logic
                    "property_address": item.internet_address,
                    "property_city": item.city,
                    "property_state": item.state,
                    "property_zip": item.zipcode,
                    "mls_abbreviation": null,
                    "mls_id": null,
                    "mls_name": null,
                },
                "idempotency_key": uuidv4(),
            };

            // console.log('send to move.com', requestBody);

            fetch(url, {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(requestBody),
            }).then(fetch(morrisUrl, {
                method: "POST",
                body: formData
            })).then(function (response) {
                console.log('fetch response ' + JSON.stringify(response));
                trackSubmitLead(item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId);
                // TRACK: dp_contact_submit
                trackClick('dp_contact_submit', `dp_contact_submit_success: ${item.ad_id},field1:${userNameValue},field2:${emailNameValue},field3:${phoneNameValue},field4:${messageNameValue},recipient:realtor.com`);
                // console.log(`dp_contact_submit_success: ${item.ad_id},field1:${userNameValue},field2:${emailNameValue},field3:${phoneNameValue},field4:${messageNameValue}`);
            }).catch(function (err) {
                console.log('fetch error ' + err);
                trackSubmitLead(item, isCommunity, reportingTrackingPath, trackingEnabled, listHubProviderId);
                console.log(`dp_contact_submit_error: ${item.ad_id},field1:${userNameValue},field2:${emailNameValue},field3:${phoneNameValue},field4:${messageNameValue}`);
            });
            //clear form
            this.setState({initialState, thanksDisplay: 'block', formDisplay: 'none', emailSent: 'true'});
        }
    }

    render() {
        const {item, affiliate, fullName, mode, isCommunity, reportingTrackingPath, trackingEnabled,
            listHubProviderId} = this.props
        let contactFormId = 'contact_form'
        let contactFormName = 'contact'
        let nameId = 'first_name'
        let emailId = 'email'
        let phoneId = 'end_user_phone'
        let messageId = 'p_messageID'
        let thanksId = 'thanks_id'
        if (mode === "mobile") {
            contactFormId = 'm_contact_form'
            contactFormName = 'm_contact'
            nameId = 'm_first_name'
            emailId = 'm_email'
            phoneId = 'm_end_user_phone'
            messageId = 'm_p_messageID'
            thanksId = 'm_thanks'
        }
        let userNameField = 'classifieds.attachment.text_attachment:21';
        let emailNameField = 'classifieds.attachment.text_attachment:22';
        let phoneNameField = 'classifieds.attachment.text_attachment:23';
        let messageNameField = 'classifieds.attachment.text_attachment:24';
        const ldpPhoneNumber = leadFormPhoneNumbers[fullName];
        const website = 'realestate.' + fullName + '.com';

        return (
            <div className="contact-form ldp-contact-form">
                <div className="title-area" style={{ display: this.state.formDisplay }}>
                    <h3>Learn more about this property</h3>
                    <a href={"tel://" + ldpPhoneNumber}>Call</a> or contact an agent to get connected
                </div>
                <form
                    name={contactFormName}
                    id={contactFormId}
                    method="post"
                    style={{ display: this.state.formDisplay }}
                    onFocus={() => {
                        if (!this.state.initialFocus) {
                            // TRACK: dp_contact_input
                            trackClick(
                                "dp_contact_input",
                                `dp_contact_input_focused: ${item.ad_id}`
                            );
                            this.setState({ initialFocus: true });
                        }
                    }}
                    onSubmit={(event) =>
                        this.handleSubmit(
                            event,
                            item,
                            isCommunity,
                            reportingTrackingPath,
                            trackingEnabled,
                            listHubProviderId
                        )
                    }>
                    <HiddenFormInputs
                        item={item}
                        isCommunity={isCommunity}
                        affiliate={affiliate}
                        fullName={fullName} />
                    <input
                        className="long_field"
                        tabIndex="1"
                        id={nameId}
                        name={userNameField}
                        type="text"
                        placeholder="Your name"
                        value={this.state[userNameField]}
                        onChange={(event) => this.handleChange(event)}
                    />
                    <div style={errorStyles}>{this.state.nameError}</div>
                    <input
                        className="long_field"
                        tabIndex="2"
                        id={emailId}
                        name={emailNameField}
                        type="text"
                        placeholder="Your email address"
                        value={this.state[emailNameField]}
                        onChange={(event) => this.handleChange(event)}
                    />
                    <div style={errorStyles}>{this.state.emailError}</div>
                    <input
                        className="long_field phone_num"
                        tabIndex="3"
                        id={phoneId}
                        name={phoneNameField}
                        type="text"
                        placeholder="Your phone number"
                        value={this.state[phoneNameField]}
                        onChange={(event) => this.handleChange(event)}
                    />
                    <div style={errorStyles}>{this.state.phoneError}</div>
                    <textarea
                        name={messageNameField}
                        id={messageId}
                        className="long_field"
                        tabIndex="4"
                        value={this.state.message}
                        onChange={(event) => {
                            this.setState({ message: event.target.value });
                        }}></textarea>
                    <label htmlFor="contact_method">Prefer:</label>
                    <input
                        type="radio"
                        name="contact_method"
                        value="text"
                        checked={this.state.contact_method === "text"}
                        onChange={(e) => {
                            this.handleChange(e);
                        }}
                    />
                    Text
                    <input
                        type="radio"
                        name="contact_method"
                        value="email"
                        checked={this.state.contact_method === "email"}
                        onChange={(e) => {
                            this.handleChange(e);
                        }}
                    />
                    Email
                    {this.state.captchaData ? (
                        <button href="#" tabIndex="5">
                            Send
                        </button>
                    ) : (
                        <ReCaptcha
                            ref={(el) => {
                                this.captchaDemo = el;
                            }}
                            size="normal"
                            data-theme="dark"
                            render="explicit"
                            sitekey="6Le50KYZAAAAADUEO0_Flf8F-Ho-L_vy_8mO1GUz"
                            onloadCallback={this.onLoadRecaptcha}
                            verifyCallback={this.verifyCallback}
                        />
                    )}
                    <div className="tcpa" id="tcpa_value">
                        By proceeding, you consent to receive calls, texts and
                        voicemails at the number you provided (may be recorded
                        and may be autodialed and use pre-recorded and
                        artificial voices), and email, from {website}, Opcity,
                        realtor.com and their network of service providers about
                        your inquiry and other home-related matters.
                        <b>
                            Msg/data rates may apply. This consent applies even
                            if you are on a do not call list and is not a
                            condition of any purchase.
                        </b>
                    </div>
                </form>
                <div
                    id={thanksId}
                    className="thanks"
                    style={{ display: this.state.thanksDisplay }}>
                    <h3>Thank you for your interest!</h3>
                    <p>An agent will be getting in touch with you shortly</p>
                </div>
            </div>
        );
    }
}

export default ListhubContactForm;